import { render, staticRenderFns } from "./shujuquanxian.vue?vue&type=template&id=3988776b&"
import script from "./shujuquanxian.vue?vue&type=script&lang=ts&"
export * from "./shujuquanxian.vue?vue&type=script&lang=ts&"
import style0 from "./shujuquanxian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports